import YoudenChart from './YoudenChart'

export default YoudenChart
